export default {
  title: "Companies",

  table: {
    noData: "Not linked to any companies yet",
  },

  input: {
    title: "New company link",
    company: "Company",
    type: "Type",
  },
}
